import { c as _c } from "react/compiler-runtime";
import { gql } from 'graphql-request';
import LoadingIndicator from 'src/components/loadingindicator/LoadingIndicator';
import { useFilminfo } from 'src/lib/client/useFilminfo';
import { useLocationContext } from "src/lib/contexts/ContextTypes";
import { useAdContext } from 'src/lib/types/ads/AdContextType';
import { type ILoaderMoviesProps } from 'src/lib/types/filminfo/ILoaderMoviesProps';
import React, { useCallback, useEffect, useRef } from 'react';
import type { SupportsScrollRestoration } from "src/lib/client/withScrollRestoration";
import withScrollRestoration from "src/lib/client/withScrollRestoration";
const BRAND = process.env.NEXT_PUBLIC_WEBSITE_BRAND;

//#region [Props]
type UpcomingMoviesLoaderProps = {
  children: React.ReactNode;
} & SupportsScrollRestoration;

//#endregion

//#region [Component]
function UpcomingMoviesLoader(t0) {
  const $ = _c(20);
  const {
    children,
    isReadyForScrollRestoration
  } = t0;
  const locContext = useLocationContext();
  let t1;
  if ($[0] !== locContext.location) {
    t1 = {
      locations: locContext.location
    };
    $[0] = locContext.location;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = locContext.isReady ?? false;
  let t3;
  if ($[2] !== t2) {
    t3 = {
      active: t2
    };
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    fiData,
    fiLoading
  } = useFilminfo(QUERY, t1, t3);
  const {
    refresh
  } = useAdContext();
  const hasRefreshedRef = useRef(false);
  let t4;
  let t5;
  if ($[4] !== fiData || $[5] !== refresh) {
    t4 = () => {
      if (BRAND === "kinodk" && fiData && !hasRefreshedRef.current) {
        hasRefreshedRef.current = true;
        refresh();
      }
    };
    t5 = [fiData, refresh];
    $[4] = fiData;
    $[5] = refresh;
    $[6] = t4;
    $[7] = t5;
  } else {
    t4 = $[6];
    t5 = $[7];
  }
  useEffect(t4, t5);
  let t6;
  if ($[8] !== isReadyForScrollRestoration) {
    t6 = node => {
      isReadyForScrollRestoration?.(true);
    };
    $[8] = isReadyForScrollRestoration;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const loadedContainer = t6;
  let t7;
  if ($[10] !== fiLoading) {
    t7 = fiLoading && <LoadingIndicator size="large" position="InlineCenter" />;
    $[10] = fiLoading;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== children || $[13] !== fiData || $[14] !== fiLoading || $[15] !== loadedContainer) {
    t8 = !fiLoading && fiData && <div ref={loadedContainer}>{React.Children.map(children, child => {
        if (React.isValidElement(child)) {
          return React.cloneElement(child, {
            movies: fiData.movieQuery?.getUpcomingMovies
          } as ILoaderMoviesProps);
        }
        return child;
      })}</div>;
    $[12] = children;
    $[13] = fiData;
    $[14] = fiLoading;
    $[15] = loadedContainer;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t7 || $[18] !== t8) {
    t9 = <div>{t7}{t8}</div>;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
}
export default withScrollRestoration(UpcomingMoviesLoader, 500);
//#endregion

//#region [Styles]

//#endregion

const QUERY = gql`
query ($locations: [String]) {
	movieQuery {
		getUpcomingMovies(locations: $locations) {
			__typename
			title
			mainVersionId
			premiere
			isPremiereConfirmed
			showsCount
            nffMovieId
			isKinoklubb
			sanityIdArt
            sanityImagePosterUrl
            sanityImageWideUrl
		}
	}
}
`;